import { BaseApiService } from "./baseApi";

interface LoginCredentials {
  email: string;
  password: string;
}

interface AuthResponse {
  token: string;
  user: {
    id: string;
    email: string;
    name: string;
    role: string;
  };
}

export class AuthApiService extends BaseApiService {
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    return this.post<AuthResponse>("/auth/login", credentials);
  }

  async adminLogin(credentials: LoginCredentials): Promise<AuthResponse> {
    return this.post<AuthResponse>("/admin/login", credentials);
  }

  async logout(): Promise<void> {
    return this.post<void>("/auth/logout");
  }

  async refreshToken(): Promise<{ token: string }> {
    return this.post<{ token: string }>("/auth/refresh");
  }

  async getProfile(): Promise<AuthResponse["user"]> {
    return this.get<AuthResponse["user"]>("/auth/profile");
  }

  async updateProfile(
    data: Partial<AuthResponse["user"]>
  ): Promise<AuthResponse["user"]> {
    return this.put<AuthResponse["user"]>("/auth/profile", data);
  }

  async changePassword(data: {
    currentPassword: string;
    newPassword: string;
  }): Promise<void> {
    return this.post<void>("/auth/change-password", data);
  }
}
